<template>
  <b-modal
    id="deleteIntModal"
    centered
    hide-footer
    hide-header
    no-close-on-backdrop
    @hidden="$bvModal.hide('deleteIntModal')"
  >
    <div class="d-flex align-items-center justify-content-between w-100">
      <div class="d-flex align-items-center w-100">
        <div class="mb-3">
          <img
            src="../../assets/New-imgs/teams-icons/teams-delete-main-icon.svg"
            alt=""
          />
        </div>
        <div class="ml-3 w-100">
          <div class="d-flex justify-content-between">
            <div class="teams-modal-head">
              <template
                v-if="
                  $route.query.status == 'interviewProcess' ||
                  Object.keys($route.query).length == 0
                "
              >
                Delete Interview Process
              </template>
              <template v-else-if="$route.query.status == 'feedbackForm'">
                Delete Feedback Form
              </template>
            </div>
            <div
              @click="$bvModal.hide('deleteIntModal')"
              class="d-flex align-items-center justify-content-end"
            >
              <img
                src="../../assets/New-imgs/teams-icons/teams-close-icon.svg"
                alt=""
                class="pointer rotate-on-hover"
              />
            </div>
          </div>

          <div
            class="mt-2 teams-delete-folder-font"
            style="width: 95%"
            v-if="
              deleteIntProcess &&
              $route.query.status == 'interviewProcess' &&
              Object.keys(deleteIntProcess).length != 0
            "
          >
            <template v-if="deleteIntProcess.jdTagged.length > 0">
              This Interview Process is tagged to
              <span class="pff-delete-modal-blue-txt"
                >{{ deleteIntProcess.jdTagged.length }} jobs</span
              >. Untag them and try again!
            </template>
            <template v-else>
              Are you sure you want to delete
              <span class="modalnamebluetext"
                >&nbsp;"{{ deleteIntProcess.name }}"</span
              >? This action cannot be undone.
            </template>
          </div>
          <div
            class="mt-1 teams-delete-folder-font"
            v-else-if="
              deletefeedbackforms &&
              $route.query.status == 'feedbackForm' &&
              Object.keys(deletefeedbackforms).length != 0
            "
          >
            <template
              v-if="deletefeedbackforms.taggedInterviewProcess.length > 0"
            >
              This feedback form is tagged to
              <span class="pff-delete-modal-blue-txt"
                >{{
                  deletefeedbackforms.taggedInterviewProcess.length
                }}
                interview process</span
              >. Untag them and try again!
            </template>
            <template v-else>
              Are you sure you want to delete
              <span class="modalnamebluetext"
                >&nbsp;"{{ deletefeedbackforms.name }}"</span
              >? This action cannot be undone.
            </template>
          </div>
        </div>
      </div>
    </div>
    <hr
      v-if="
        ($route.query.status == 'interviewProcess' &&
          deleteIntProcess &&
          deleteIntProcess.jdTagged &&
          deleteIntProcess.jdTagged.length != 0) ||
        ($route.query.status == 'feedbackForm' &&
          deletefeedbackforms &&
          deletefeedbackforms.taggedInterviewProcess &&
          deletefeedbackforms.taggedInterviewProcess.length != 0)
      "
    />
    <div
      v-if="
        $route.query.status == 'interviewProcess' &&
        deleteIntProcess &&
        deleteIntProcess.jdTagged &&
        deleteIntProcess.jdTagged.length != 0
      "
    >
      <div class="tagged-jobs">Tagged Jobs</div>
      <div class="deleteIntModal-tagged-jobs-height mt-2">
        <div
          class="deleteIntModal-tagged-jobs-card wordbreak"
          :class="index >= 1 ? 'mt-3' : ''"
          v-for="(i, index) in deleteIntProcess.jdTagged"
          :key="index"
        >
          {{ i.jobName }}
        </div>
      </div>
    </div>
    <div
      v-else-if="
        $route.query.status == 'feedbackForm' &&
        deletefeedbackforms &&
        deletefeedbackforms.taggedInterviewProcess &&
        deletefeedbackforms.taggedInterviewProcess.length != 0
      "
    >
      <div class="tagged-jobs">Tagged Interview Process</div>
      <div class="deleteIntModal-tagged-jobs-height mt-2">
        <div
          class="deleteIntModal-tagged-jobs-card"
          :class="index >= 1 ? 'mt-3' : ''"
          v-for="(i, index) in deletefeedbackforms.taggedInterviewProcess"
          :key="index"
        >
          {{ i.name }}
        </div>
      </div>
    </div>
    <hr
      v-if="
        ($route.query.status == 'interviewProcess' &&
          deleteIntProcess &&
          deleteIntProcess.jdTagged &&
          deleteIntProcess.jdTagged.length != 0) ||
        ($route.query.status == 'feedbackForm' &&
          deletefeedbackforms &&
          deletefeedbackforms.taggedInterviewProcess &&
          deletefeedbackforms.taggedInterviewProcess.length != 0)
      "
    />

    <div class="d-flex align-items-center justify-content-end mt-4 bluebtn">
      <b-button
        class="new-whiteBtn mr-3"
        @click="$bvModal.hide('deleteIntModal')"
        >Cancel</b-button
      >
      <b-button
        :disabled="
          ($route.query.status == 'interviewProcess' &&
            deleteIntProcess &&
            deleteIntProcess.jdTagged &&
            deleteIntProcess.jdTagged.length != 0) ||
          ($route.query.status == 'feedbackForm' &&
            deletefeedbackforms &&
            deletefeedbackforms.taggedInterviewProcess &&
            deletefeedbackforms.taggedInterviewProcess.length != 0)
        "
        class="new-blueBtn"
        @click="
          $route.query.status === 'interviewProcess'
            ? deleteInterviewProcess()
            : deletefeedbackform()
        "
        >Delete</b-button
      >
    </div>
  </b-modal>
</template>
<script>
import {
  delteintprocess,
  deletefeedbackform,
} from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";

export default {
  name: "DeleteModal",
  props: {
    deleteIntProcess: Object,
    deletefeedbackforms: Object,
  },
  mixins: [toast],

  data() {
    return {
      loopvar: 10,
    };
  },
  methods: {
    async deleteInterviewProcess() {
      try {
        let response = await delteintprocess(this.deleteIntProcess);
        if (response.status == 200) {
          this.$bvModal.hide("deleteIntModal");
          this.$emit("resetPagination");

          this.successModal("Interview process deleted successfully!");
        } else {
          this.errorModal("something went wrong");
        }
      } catch (error) {
        throw new Error(`Failed! Deleting :${error.status}`);
      }
    },
    async deletefeedbackform() {
      let payload = {
        feedbackFormID: this.deletefeedbackforms.feedbackFormID,
      };
      const res = await deletefeedbackform(payload);
      if (res.status == 200) {
        this.$bvModal.hide("deleteIntModal");
        this.$emit("resetPagination");
        this.successModal("Feedback Form deleted successfully!");
      } else {
        this.errorModal("something went wrong");
      }
    },
  },
};
</script>
<style scoped>
.tagged-jobs {
  font-weight: 500;
  font-size: 15px;
}
</style>
